/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CvSearchPresetDto } from '../models';
// @ts-ignore
import type { CvSearchPresetSortByDto } from '../models';
// @ts-ignore
import type { GetCvSearchPresetsResponseDto } from '../models';
// @ts-ignore
import type { SaveCvSearchPresetRequestDto } from '../models';
// @ts-ignore
import type { SortDirectionDto } from '../models';
/**
 * CvSearchPresetsRestApi - axios parameter creator
 */
export const CvSearchPresetsRestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Save current search criteria as a named shared preset
         * @param {SaveCvSearchPresetRequestDto} saveCvSearchPresetRequestDto Criteria to save as a new CV Search preset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCvSearchPreset: async (saveCvSearchPresetRequestDto: SaveCvSearchPresetRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'saveCvSearchPresetRequestDto' is not null or undefined
            assertParamExists('createCvSearchPreset', 'saveCvSearchPresetRequestDto', saveCvSearchPresetRequestDto)
            const localVarPath = `/api/v1/cv-search/presets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveCvSearchPresetRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an own preset
         * @param {number} presetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCvSearchPreset: async (presetId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'presetId' is not null or undefined
            assertParamExists('deleteCvSearchPreset', 'presetId', presetId)
            const localVarPath = `/api/v1/cv-search/presets/{presetId}`
                .replace('{presetId}', encodeURIComponent(String(presetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Presets are shared: everyone can browse and load them, only the author can update or delete. Items carry full criteria (tag expression and keywords). Default sort is createdAt desc. Name phrase is matched case-insensitively. 
         * @summary Search shared CV Search presets (saved filters)
         * @param {string} [name] Case-insensitive phrase matched against the preset name.
         * @param {string} [createdBy] Filters presets to the ones created by this user.
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {CvSearchPresetSortByDto} [sortBy] 
         * @param {SortDirectionDto} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCvSearchPresets: async (name?: string, createdBy?: string, page?: number, pageSize?: number, sortBy?: CvSearchPresetSortByDto, sortOrder?: SortDirectionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/cv-search/presets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (createdBy !== undefined) {
                localVarQueryParameter['createdBy'] = createdBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Overwrite an own preset with new criteria
         * @param {number} presetId 
         * @param {SaveCvSearchPresetRequestDto} saveCvSearchPresetRequestDto Criteria to overwrite an own CV Search preset with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvSearchPreset: async (presetId: number, saveCvSearchPresetRequestDto: SaveCvSearchPresetRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'presetId' is not null or undefined
            assertParamExists('updateCvSearchPreset', 'presetId', presetId)
            // verify required parameter 'saveCvSearchPresetRequestDto' is not null or undefined
            assertParamExists('updateCvSearchPreset', 'saveCvSearchPresetRequestDto', saveCvSearchPresetRequestDto)
            const localVarPath = `/api/v1/cv-search/presets/{presetId}`
                .replace('{presetId}', encodeURIComponent(String(presetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveCvSearchPresetRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CvSearchPresetsRestApi - functional programming interface
 */
export const CvSearchPresetsRestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CvSearchPresetsRestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Save current search criteria as a named shared preset
         * @param {SaveCvSearchPresetRequestDto} saveCvSearchPresetRequestDto Criteria to save as a new CV Search preset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCvSearchPreset(saveCvSearchPresetRequestDto: SaveCvSearchPresetRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CvSearchPresetDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCvSearchPreset(saveCvSearchPresetRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CvSearchPresetsRestApi.createCvSearchPreset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete an own preset
         * @param {number} presetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCvSearchPreset(presetId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCvSearchPreset(presetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CvSearchPresetsRestApi.deleteCvSearchPreset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Presets are shared: everyone can browse and load them, only the author can update or delete. Items carry full criteria (tag expression and keywords). Default sort is createdAt desc. Name phrase is matched case-insensitively. 
         * @summary Search shared CV Search presets (saved filters)
         * @param {string} [name] Case-insensitive phrase matched against the preset name.
         * @param {string} [createdBy] Filters presets to the ones created by this user.
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {CvSearchPresetSortByDto} [sortBy] 
         * @param {SortDirectionDto} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCvSearchPresets(name?: string, createdBy?: string, page?: number, pageSize?: number, sortBy?: CvSearchPresetSortByDto, sortOrder?: SortDirectionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCvSearchPresetsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCvSearchPresets(name, createdBy, page, pageSize, sortBy, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CvSearchPresetsRestApi.getCvSearchPresets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Overwrite an own preset with new criteria
         * @param {number} presetId 
         * @param {SaveCvSearchPresetRequestDto} saveCvSearchPresetRequestDto Criteria to overwrite an own CV Search preset with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCvSearchPreset(presetId: number, saveCvSearchPresetRequestDto: SaveCvSearchPresetRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CvSearchPresetDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCvSearchPreset(presetId, saveCvSearchPresetRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CvSearchPresetsRestApi.updateCvSearchPreset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CvSearchPresetsRestApi - factory interface
 */
export const CvSearchPresetsRestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CvSearchPresetsRestApiFp(configuration)
    return {
        /**
         * 
         * @summary Save current search criteria as a named shared preset
         * @param {SaveCvSearchPresetRequestDto} saveCvSearchPresetRequestDto Criteria to save as a new CV Search preset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCvSearchPreset(saveCvSearchPresetRequestDto: SaveCvSearchPresetRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CvSearchPresetDto> {
            return localVarFp.createCvSearchPreset(saveCvSearchPresetRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an own preset
         * @param {number} presetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCvSearchPreset(presetId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCvSearchPreset(presetId, options).then((request) => request(axios, basePath));
        },
        /**
         * Presets are shared: everyone can browse and load them, only the author can update or delete. Items carry full criteria (tag expression and keywords). Default sort is createdAt desc. Name phrase is matched case-insensitively. 
         * @summary Search shared CV Search presets (saved filters)
         * @param {string} [name] Case-insensitive phrase matched against the preset name.
         * @param {string} [createdBy] Filters presets to the ones created by this user.
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {CvSearchPresetSortByDto} [sortBy] 
         * @param {SortDirectionDto} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCvSearchPresets(name?: string, createdBy?: string, page?: number, pageSize?: number, sortBy?: CvSearchPresetSortByDto, sortOrder?: SortDirectionDto, options?: RawAxiosRequestConfig): AxiosPromise<GetCvSearchPresetsResponseDto> {
            return localVarFp.getCvSearchPresets(name, createdBy, page, pageSize, sortBy, sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Overwrite an own preset with new criteria
         * @param {number} presetId 
         * @param {SaveCvSearchPresetRequestDto} saveCvSearchPresetRequestDto Criteria to overwrite an own CV Search preset with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvSearchPreset(presetId: number, saveCvSearchPresetRequestDto: SaveCvSearchPresetRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CvSearchPresetDto> {
            return localVarFp.updateCvSearchPreset(presetId, saveCvSearchPresetRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CvSearchPresetsRestApi - interface
 */
export interface CvSearchPresetsRestApiInterface {
    /**
     * 
     * @summary Save current search criteria as a named shared preset
     * @param {SaveCvSearchPresetRequestDto} saveCvSearchPresetRequestDto Criteria to save as a new CV Search preset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCvSearchPreset(saveCvSearchPresetRequestDto: SaveCvSearchPresetRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CvSearchPresetDto>;

    /**
     * 
     * @summary Delete an own preset
     * @param {number} presetId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteCvSearchPreset(presetId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Presets are shared: everyone can browse and load them, only the author can update or delete. Items carry full criteria (tag expression and keywords). Default sort is createdAt desc. Name phrase is matched case-insensitively. 
     * @summary Search shared CV Search presets (saved filters)
     * @param {string} [name] Case-insensitive phrase matched against the preset name.
     * @param {string} [createdBy] Filters presets to the ones created by this user.
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {CvSearchPresetSortByDto} [sortBy] 
     * @param {SortDirectionDto} [sortOrder] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCvSearchPresets(name?: string, createdBy?: string, page?: number, pageSize?: number, sortBy?: CvSearchPresetSortByDto, sortOrder?: SortDirectionDto, options?: RawAxiosRequestConfig): AxiosPromise<GetCvSearchPresetsResponseDto>;

    /**
     * 
     * @summary Overwrite an own preset with new criteria
     * @param {number} presetId 
     * @param {SaveCvSearchPresetRequestDto} saveCvSearchPresetRequestDto Criteria to overwrite an own CV Search preset with
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCvSearchPreset(presetId: number, saveCvSearchPresetRequestDto: SaveCvSearchPresetRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CvSearchPresetDto>;

}

/**
 * CvSearchPresetsRestApi - object-oriented interface
 */
export class CvSearchPresetsRestApi extends BaseAPI implements CvSearchPresetsRestApiInterface {
    /**
     * 
     * @summary Save current search criteria as a named shared preset
     * @param {SaveCvSearchPresetRequestDto} saveCvSearchPresetRequestDto Criteria to save as a new CV Search preset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createCvSearchPreset(saveCvSearchPresetRequestDto: SaveCvSearchPresetRequestDto, options?: RawAxiosRequestConfig) {
        return CvSearchPresetsRestApiFp(this.configuration).createCvSearchPreset(saveCvSearchPresetRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an own preset
     * @param {number} presetId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteCvSearchPreset(presetId: number, options?: RawAxiosRequestConfig) {
        return CvSearchPresetsRestApiFp(this.configuration).deleteCvSearchPreset(presetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Presets are shared: everyone can browse and load them, only the author can update or delete. Items carry full criteria (tag expression and keywords). Default sort is createdAt desc. Name phrase is matched case-insensitively. 
     * @summary Search shared CV Search presets (saved filters)
     * @param {string} [name] Case-insensitive phrase matched against the preset name.
     * @param {string} [createdBy] Filters presets to the ones created by this user.
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {CvSearchPresetSortByDto} [sortBy] 
     * @param {SortDirectionDto} [sortOrder] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCvSearchPresets(name?: string, createdBy?: string, page?: number, pageSize?: number, sortBy?: CvSearchPresetSortByDto, sortOrder?: SortDirectionDto, options?: RawAxiosRequestConfig) {
        return CvSearchPresetsRestApiFp(this.configuration).getCvSearchPresets(name, createdBy, page, pageSize, sortBy, sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Overwrite an own preset with new criteria
     * @param {number} presetId 
     * @param {SaveCvSearchPresetRequestDto} saveCvSearchPresetRequestDto Criteria to overwrite an own CV Search preset with
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCvSearchPreset(presetId: number, saveCvSearchPresetRequestDto: SaveCvSearchPresetRequestDto, options?: RawAxiosRequestConfig) {
        return CvSearchPresetsRestApiFp(this.configuration).updateCvSearchPreset(presetId, saveCvSearchPresetRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

